import React from "react";

import MuiAutocompleteMultiSelect, {
  MuiAutocompleteMultiSelectProps,
} from "./MuiAutocompleteMultiSelect";

interface StoreMultiSelectProps<T> extends Omit<MuiAutocompleteMultiSelectProps<T>, "multiSelect"> {
  single?: boolean;
  autoCommit?: boolean;
}

const StoreMultiSelect = <T,>({
  single = false,
  autoCommit: _autoCommit,
  ...props
}: StoreMultiSelectProps<T>) => {
  return <MuiAutocompleteMultiSelect {...props} multiSelect={!single} />;
};

export default StoreMultiSelect;
